import { GsapAnimation } from '../gsap/_gsap';

// Gsapアニメーションクラスのインスタンスを生成
const gsap = new GsapAnimation();

export const loadingFunc = () => {
  /**
   * 画面ロード後のアクション
   */
  {
    // 画面スクロールを無効にする
    const body = document.querySelector('html body');
    body.style.position = 'fixed';
    body.style.overflow = 'hidden';

    window.addEventListener('load', function () {
      // MV画像を少しずつ縮小させる
      const mvImg = document.querySelector('.js-mvImg1');
      this.setTimeout(function () {
        mvImg.classList.add('is--scaleOut');
      }, 2000);

      // MVテキストのアニメーションを開始
      const text1 = document.querySelector('.js-mvText1');
      const text2 = document.querySelector('.js-mvText2');
      const text3 = document.querySelector('.js-mvText3');
      text1 && gsap.bottomToTop(text1, 2.6, 0);
      text2 && gsap.bottomToTop(text2, 2, 0.9);
      text3 && gsap.bottomToTop(text3, 2.4, 0.9);

      this.setTimeout(function () {
        // 2.0秒後、黒い帯を動かす
        document.querySelectorAll('.js-mvCurtainInner > div').forEach(function (item) {
          item.classList.add('is--animate');
        });
      }, 2000);

      this.setTimeout(function () {
        // 3.4秒後、画面スクロールを有効する
        body.style.position = 'static';
        body.style.overflow = 'visible';

        // 3.4秒後、黒い帯を消す
        document.querySelector('.js-mvCurtain').classList.add('is--fadeOut');
      }, 3400);

      this.setTimeout(function () {
        // 3秒後、ヘッダー・CTAに is--loadクラスを付与（ロゴ等のフェードインの為）
        const header = document.querySelector('.l-header');
        const cta = document.querySelector('.p-home-cta');
        header.classList.add('is--load');
        cta.classList.add('is--load');
      }, 3000);
    });
  }
};
